var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-ignore
import { fetchConsultar, fetchConsultarPaginada, fetchCadastrar, fetchAlterar, fetchDeletar, URL_API, } from '../../../api';
import { getTokenFromCookie } from '../../../services/mt_login';
export { STATUS_API } from '../../../api';
var ROTA_JUSTIFICATIVAS = 'justificativas';
export var getJustificativas = function (Filtros, PaginationModel) { return __awaiter(void 0, void 0, void 0, function () {
    var Query, URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Query = '';
                if (Filtros === null || Filtros === void 0 ? void 0 : Filtros.justificativa)
                    Query += "justificativa=".concat(encodeURIComponent(Filtros.justificativa), "&");
                if (Filtros === null || Filtros === void 0 ? void 0 : Filtros.codigo)
                    Query += "codigo=".concat(encodeURIComponent(Filtros.codigo), "&");
                if (Filtros === null || Filtros === void 0 ? void 0 : Filtros.descricao)
                    Query += "descricao=".concat(encodeURIComponent(Filtros.descricao), "&");
                if (Filtros === null || Filtros === void 0 ? void 0 : Filtros.situacao)
                    Query += "situacao=".concat(encodeURIComponent(Filtros.situacao), "&");
                URL = "".concat(ROTA_JUSTIFICATIVAS, "?").concat(Query);
                return [4 /*yield*/, fetchConsultarPaginada(URL, PaginationModel)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarSituacaoJustificativa = function (ID, situacao) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchAlterar("".concat(ROTA_JUSTIFICATIVAS, "/").concat(ID, "/alterar-situacao?situacao=").concat(situacao))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getJustificativa = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_JUSTIFICATIVAS, "/").concat(ID))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarJustificativa = function (Dados) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchCadastrar("".concat(ROTA_JUSTIFICATIVAS), Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarJustificativa = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchAlterar("".concat(ROTA_JUSTIFICATIVAS, "/").concat(ID), Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var excluirJustificativa = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchDeletar("".concat(ROTA_JUSTIFICATIVAS, "/").concat(ID))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// Abre o anexo (PDF/JPG) em nova aba para visualização/download.
export var abrirAnexoJustificativa = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL, TOKEN, response, blob, blobUrl, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(URL_API, "/").concat(ROTA_JUSTIFICATIVAS, "/").concat(ID, "/anexo");
                TOKEN = getTokenFromCookie();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(URL, {
                        method: 'GET',
                        headers: { Authorization: "Bearer ".concat(TOKEN) },
                    })];
            case 2:
                response = _a.sent();
                if (!response.ok)
                    throw new Error('Falha ao carregar o anexo');
                return [4 /*yield*/, response.blob()];
            case 3:
                blob = _a.sent();
                blobUrl = window.URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
                return [2 /*return*/, true];
            case 4:
                error_1 = _a.sent();
                console.error('Erro ao abrir anexo:', error_1);
                return [2 /*return*/, false];
            case 5: return [2 /*return*/];
        }
    });
}); };
